/**
 * Phase 16F deep link `/notifications/:id` (REQ-NTF-07: the email links here; the id is opaque).
 *
 * The dashboard uses section state, not routes, so this remembers the id for the tab
 * (sessionStorage) and goes to the dashboard; NotificationProvider then loads it with
 * GET /notifications?id= and opens its deep link. `/notifications` (the batched email) opens the panel. Signed out, the same route sends the user to
 * sign-in first, and the dashboard picks the id up after login.
 */
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { PENDING_INBOX, PENDING_NOTIFICATION_KEY } from '../../context/NotificationContext';

const ID_PATTERN = /^[A-Za-z0-9_-]{1,128}$/;

/** Remembers the id (or, for `/notifications` with no id, "open the inbox"). */
export function rememberPendingNotification(id: string | undefined): boolean {
  if (id !== undefined && !ID_PATTERN.test(id)) return false;
  try {
    sessionStorage.setItem(PENDING_NOTIFICATION_KEY, id ?? PENDING_INBOX);
    return true;
  } catch {
    return false;
  }
}

const NotificationRedirect: React.FC<{ to: '/dashboard' | '/login' }> = ({ to }) => {
  const { id } = useParams<{ id: string }>();
  rememberPendingNotification(id);
  return <Navigate to={to} replace />;
};

export default NotificationRedirect;
